/**
 * 业务应用的国际化文件：<中文>
 *
 * 在html属性中的使用示例：（注意属性名字前要有冒号）
 * <el-tooltip :content="$t('m.notice')" placement="bottom">
 * 在html模版中的使用示例：
 * <span>{{ $t('m.welcome') }}</span>
 * 在js代码中的使用示例：
 * window.document.title = this.$t('m.projectTitle')
 * 支持动态属性示例：
 * {{ $t(`m.${scope.row.operationStatus}`) }}
 *
 * 注意1:
 *    公用的国际化标识是以'c.'开头,
 *    业务应用的国际化默认是以'm.'开头, 可以自行调整
 *    但是不可以使用c(公用的)和el(ElementUI的), 避免冲突
 * 注意2:
 *    属性名称使用首字母小写的驼峰格式命名, 或下划线分隔单词
 *    必须使用英文，禁止使用拼音及拼音简写
 *    尽量做到望文知义，可以长一些，再长一些，保证代码可阅读性
 *    正确：projectTitle, studentName, min_waiting_time
 *    正确：loginPasswordVerifyFailedAutoUnlockPeriod,即：登录密码验证失败自动解锁时长
 *    正确：login_collision_attack_failed_count,即：登录碰撞攻击失败次数
 *    错误：name(这是什么阿猫阿狗), shijian(拼音时间或是事件或是??), pyjx(我猜是拼音简写, 错! 正确答案, 嗯...让我想想)
 * @author luwei
 * @version 1.0.0, 2019-03-16
 */
export const m = {
  // 业务项目名称, 必填项
  //projectTitle: '四川省外事管理申报系统',
  projectTitle: '东方电气外事管理服务系统',
  //projectTitle: '诺君安外事管理服务平台',
  auditLog: {
    "reset": "重置",
    "name": "名称",
    "high": "高",
    "medium": "中",
    "low": "低",
    "code": "编码",
    "level": "级别",
    "confirmResetAuditType": "确认重置审计类型吗?",
    "resetSuccess": "重置成功",
    userId: '用户ID',
    userAccount: '用户账号',
    realName: '真实姓名',
    ipAddr: 'IP地址',
    macAddr: 'MAC ADDR',
    hostName: '主机名',
    clientType: '客户端',
    userAgent: 'USER AGENT',
    catgory: '日志分类',
    itemCode: '审计项编码',
    operateType: '操作类型',
    operateTime: '操作时间',
    operation: '功能点',
    sqlLikeFields: '用户账号, IP地址, USER AGENT',
    auditLog: '审计日志查询',
    methodName: '方法名称'
  },
  dataxTask: {
    appId: '应用ID',
    resourceTag: '资源标识',
    taskName: '任务名称',
    groupName: '任务分组',
    transferType: '传输类型',
    taskDesc: '任务说明',
    sqlLikeFields: '资源标识, 任务名称, 任务分组, 任务说明',
    dataxTask: '本地数据交换服务任务定义'
  },
  httpAsync: {
    resourceTag: '资源标识',
    result: '业务数据',
    submitStatus: '提交状态',
    httpAsync: 'HTTP异步处理记录'
  },
  filePush: {
    resourceTag: '资源标识',
    filePath: '文件路径',
    submitStatus: '提交状态',
    sqlLikeFields: '资源标识, 文件路径',
    filePush: '文件推送记录'
  },
  dataxStatusLocal: {
    resourceTag: '资源标识',
    code: '结果编码',
    msg: '结果信息',
    linkId: '关联业务ID',
    fileName: '文件名称',
    submitStatus: '提交状态',
    sqlLikeFields: '资源标识, 结果信息, 文件名称',
    dataxStatusLocal: '本地处理状态记录'
  },
  dataxStatusThird: {
    resourceTag: '资源标识',
    code: '结果编码',
    msg: '结果信息',
    linkId: '关联业务ID',
    fileName: '文件名称',
    handleStatus: '处理状态',
    handleNote: '处理说明',
    sqlLikeFields: '资源标识, 结果信息, 文件名称',
    dataxStatusThird: '三方处理状态记录'
  },
  user: {
    userAccount: '用户账号',
    passwd: '用户密码',
    salt: '加密盐值',
    userPersonAprvStatus: '人员状态',
    userRoleAprvStatus: '角色状态',
    status: '用户状态',
    userType: '用户类型',
    personId: '关联人员',
    orgId: '所属组织',
    bindSerialNumber: '绑定证书编码',
    sqlLikeFields: '用户账号',
    checkRoles: '请勾选角色',
    resetPwd: '重置密码',
    user: '用户账户',
    useUsbkeyAccount: '证书作为账号'
  },
  menu: {
    menuName: '菜单名称',
    menuNote: '菜单说明',
    menuUri: '菜单地址',
    menuIcon: '菜单图标',
    orderBy: '菜单序号',
    detail: '菜单备注',
    "approvalEndpoint": "审批端",
    "declarationEndpoint": "申报端",
    "mobileEndpoint": "移动端",
    "addPrimaryMenu": "新增一级菜单",
    "associatedFunction": "关联功能",
    "pleaseEnterFunctionNameOrOverviewForFuzzySearch": "请输入功能名称/概述，支持模糊查询",
    "isAssociated": "是否关联",
    "no": "否",
    "yes": "是",
    "functionName": "功能名称",
    "functionOverview": "功能概述",
    "userInformationDetails": "用户信息详情",
    "roleDescription": "角色说明",
    "pleaseFillInMenuName": "请填写菜单名称",
    "pleaseSelectMenuIcon": "请选择菜单图标",
    "home": "首页",
    "menuHasMaintainedAssociatedFunctionsPleaseClearAssociatedFunctionsBeforeAddingSubmenus": "菜单已维护关联功能，请清空关联功能后，再新增子菜单",
    "modificationSuccessful": "修改成功",
    "deletionSuccessful": "删除成功",
    "moveUp": "上移",
    "moveDown": "下移",
    "authorizeRoles": "授权角色",
    "addSubmenu": "新增子菜单",
    "pleaseSelectMenuToAuthorize": "请选择要授权的菜单",
    "pleaseSelectRoleBeforeSaving": "请选择角色后再进行保存",
    "confirmToAuthorize": "确定要将",
    "authorizeSelectedRoles": "授权给选中角色吗?",
    "andSubmenusAuthorizedToSelectedRoles": "及其子菜单授权给选中角色吗?",
    "menuAuthorizationRoleHint": "菜单授权角色提示",
    "menuAuthorizationSuccess": "菜单授权成功"
  },
  parameter: {
    oneName: '参数一级分组名称',
    oneDesc: '参数一级分组描述',
    twoName: '参数二级分组名称',
    twoDesc: '参数二级分组描述',
    paramName: '参数名称',
    paramDesc: '参数描述',
    paramValue: '参数值',
    paramExtra: '参数扩展值',
    sqlLikeFields:
      '参数一级分组名称, 参数一级分组描述, 参数二级分组名称, 参数二级分组描述, 参数名称, 参数描述',
    parameter: '系统参数'
  },
  upgradeConfig: {
    parentId: '应用名称',
    dataType: '发布时间',
    dataTag: '固定标签',
    dataName: '版本号',
    dataText: '参数升级JSON',
    sqlLikeFields: '版本号',
    upgradeConfig: '应用配置参数升级管理'
  },
  flowBusiness: {
    nodeKey: '节点标识',
    businessName: '业务名称',
    remarks: '说明',
    flowBusiness: '流程业务模块表'
  },
  sysSequence: {
    type: '流水号分类',
    subType: '打印件类型',
    dateType: '流水号日期格式',
    fowNum: '流水号长度',
    value: '前当流水号',
    prefix: '流水号前缀',
    suffix: '流水号后缀',
    cancel: '流水号作废',
    decrement: '缩减度',
    sysSequence: '流水号信息表',
    "serialNumberUsage": "流水号用途",
    "usingOrganization": "使用单位",
    "maxValue": "最大值",
    "writeOffSerialNumber": "作废流水号",
    "startNumber": "起始号",
    "endNumber": "截止号",
    "serialNumberCode": "流水号编码",
    "serialNumberFormatExample": "流水号格式示例",
    "writeOffSuccess": "作废成功",
    "normal": "正常"
  },
  dyndictionary: {
    id: '编号',
    dicttype: '字典类型',
    parentcode: '父类字典',
    dictname: '字典名称',
    description: '描述',
    hardcode: '硬编码',
    code: 'Code编码',
    dictno: '字典编号',
    dictKey: '字典Key',
    dyndictionary: '数据字典表'
  },
  country: {
    countrycode: '国家编号',
    abbr2: '国家代码两位',
    abbr3: '国家代码三位',
    fullenname: '英文全称',
    shortenname: '英文简称',
    fullcnname: '中文全称',
    shortcnname: '中文简称',
    continentid: '所属大洲',
    lastupdate: '最后更新日期',
    restricted: '受控标识',
    remarks: '备注',
    isIndex: '占用计划指标',
    country: '国家基础信息表',
    isLatinAmerica: '属于拉丁美洲',
    signDays: '送签天数'
  },
  noticeManage: {
    title: '标题',
    showTimeStart: '展示起始',
    showTimeEnd: '展示结束',
    showPriority: '优先级',
    articleType: '文章类型',
    articleSource: '文章来源',
    articleContent: '文章内容',
    articleSummary: '文章概述',
    publishArea: '发布区域',
    publishStatus: '发布状态',
    publishTime: '发布时间',
    noticeManage: '通知通告管理'
  },
  visitunit: {
    visitUnit: '拜访单位',
    visitResult: '出访成果',
    vip: '重要人士',
    talkMatter: '洽谈事项',
    nextTodo: '后续推进事项',
    visitunit: '出访单位信息'
  },
  sumOrg: {
    orgCode: '机构编码',
    parentCode: '上级编码',
    provinceSystemCode: '省系统编码',
    fullName: '机构全称',
    shortName: '机构简称',
    creditCode: '社会统一信用码',
    leader: '管理员',
    zoneCode: '所属地区',
    unitNature: '单位性质',
    unitCategory: '行业类型',
    unitClassification: '单位分类',
    approvalAuthority: '是否有审批权',
    passportAuthority: '是否有护照保管权',
    applyDroit: '是否有申报权',
    seqIndex: '单位排序显示',
    remarks: '备注',
    nodeLevel: '单位级别',
    status: '状态',
    expireDate: '服务有效期',
    sumOrg: '机构表信息',
    "organization": "机构",
    "fullName": "全称",
    "enterFullOrganizationNameConsistentWithSeal": "输入单位全称，应与公章文字一致",
    "shortName": "简称",
    "enterRecordedOrganizationShortName": "请输入备案单位简称",
    "organizationCode": "机构代码",
    "organizationCreatedSuccessfullyAutomaticallyGenerated": "机构创建成功后系统自动生成",
    "type": "类型",
    "selectUnitClassification": "请选择单位分类",
    "selectUnitNature": "请选择单位性质",
    "selectIfHavePassportCustodyRight": "请选择是否有护照保管权",
    "selectIfHaveApprovalRight": "请选择是否有审批权",
    "enterAdministratorNameForRecord": "请输入单位备案的管理员姓名",
    "contactPhone": "联系电话",
    "enterAdministratorContactPhoneForRecord": "请输入单位备案的管理员联系电话",
    "responsibleLeader": "分管领导",
    "selectResponsibleLeaderOfThisUnit": "请选择本单位的分管领导",
    "filterByKeyWord": "输入关键字进行过滤",
    "phone": "电话",
    "requestDocumentHeader": "请示件文头",
    "enterRequestDocumentHeader": "请输入请示件文头",
    "organizationSealImage": "机构公章图片",
    "icon": "图标",
    "fileType": "文件类型",
    "header": "文头",
    "enterHeader": "请输入文头",
    "enterFullOrganizationName": "请输入单位全称",
    "enterShortOrganizationName": "请输入单位简称",
    "saveOrganizationInfoBeforeSettings": "请先保存机构信息再进行设置",
    "confirmDeleteSealImageContinue": "确定删除公章图片吗, 是否继续?",
    "uploadSealImageSizeCannotExceed1MB": "上传公章图片大小不能超过 1MB!",
    "uploadImageWidthAndHeightCannotExceed800Pixels": "上传图片宽度不能超过800像素，高度不能超过800像素",
    "pleaseEnterFullOrganizationName": "请输入机构全称",
    "pleaseEnterShortOrganizationName": "请输入机构简称",
    "pleaseEnterAdministrator": "请输入管理员",
    "isDisabled": "是否禁用",
    "pleaseSelectIsDisabled": "请选择是否禁用",
    "approvalMethod": "审批方式",
    "setValidityPeriod": "设置有效期",
    "unban": "解禁",
    "ban": "禁用",
    "confirmDisableOrganization": "确定要禁用该机构吗?",
    "confirmUnbanOrganization": "确定要解禁该机构吗?",
    "setServiceValidityPeriod": "设置服务有效期",
    "salesPerson": "销售人",
    "salesPersonName": "销售人员姓名",
    "purchaseDate": "购买日期",
    "selectDate": "选择日期",
    "serviceValidityDeadline": "服务有效截止日期",
    "validDate": "有效日期",
    "pleaseEnterSalesPerson": "请输入销售人",
    "pleaseEnterPurchaseDate": "请输入购买日期",
    "pleaseEnterServiceValidDate": "请输入服务有效日期",
    "setValidityPeriodSuccessfully": "设置有效期成功",
    "setApprovalMethod": "设置审批方式",
    "warmPrompt": "温馨提示：在这里可以根据自已单位的实际情况设置审批方式",
    "organizationName": "单位名称",
    "businessType": "业务类型",
    "pleaseSelectApprovalMethod": "请选择审批方式",
    "pleaseSaveDataBeforeOperation": "操作之前请先将正在操作的数据保存",
    "selectAll": "全选",
    "roleAuthorization": "角色授权",
    "primaryMenu": "一级菜单",
    "subMenu": "子菜单"
  },
  sysDict: {
    dictName: '字典名称',
    dictEname: '字典英文名称',
    dictSpec: '字典标准',
    dictType: '字典类型',
    remarks: '备注',
    orderNo: '显示顺序',
    status: '状态',
    sysDict: '字典表信息',
    "addDictionary": "新增字典",
    "pleaseEnterDictionaryNameOrRelatedBusiness": "请输入字典名称或关联业务",
    "dictionaryItemStatus": "字典项状态",
    "normal": "正常",
    "initial": "初始",
    "viewSubordinate": "查看下级",
    "addSubordinate": "添加下级",
    "enable": "启用",
    "initiallyEnabled": "初始启用",
    "dictionaryItemCode1": "字典项编码1",
    "dictionaryItemCode2": "字典项编码2",
    "confirmCancelDictionaryItemCustomization": "确定取消字典项定制吗？",
    "confirmDictionary": "确定对（",
    ItemCustomization: "）字典进行字典项定制吗？",
    "cancelCustomizationSuccess": "取消定制成功",
    "customDictionarySuccess": "定制字典成功",
    "confirmToInitiallyEnableDictionaryItem": "确认要初始启用该字典项吗，启用后不可删除?",
    "confirmToDisableDictionaryItem": "确认要禁用该字典项吗?",
    "confirmToEnableDictionaryItem": "确认要启用该字典项吗?",
    "onlyInitialStatusDictionaryItemsCanBeDeleted": "只有初始状态的字典项可删除！",
    "dictionaryItemNotInInitialStatus": "字典项非初始状态。",
    "deletionSuccess": "删除成功",
    "pleaseSelectParentDictionaryFirst": "请先选择父字典",
    "subordinateDataIsEmpty": "下级数据为空",
    "operationSuccess": "操作成功",
    "pleaseSelectParentDictionary": "请先选择父字典",
    "associatedBusiness": "关联业务",
    "pleaseEnterAssociatedBusiness": "请输入关联业务",
    "englishName": "英文名称",
    "confirmSave": "是否确认保存?",
    "roleNotAssignedDictionaryManagementPagePermission": "角色未分配字典管理页面的权限，是否确认授权?",
    "roleAuthorization": "角色授权",
    "dictionary": "字典"
  },
  sysDictItem: {
    itemName: '字典项名称',
    hardCode: '字典项编码',
    thirdpartyHardCode: '其它业务字典项编码',
    itemValue: '字典项值',
    parentId: '父字典项ID',
    sysDictItem: '字典项表信息',
    "serialNumberInfo": "流水号信息",
    "suchAs": "如：请示件文号、团组编号等",
    "exampleCode": "如：ABROADPLANAPPROVALNO",
    "serialNumberDigits": "流水号位数",
    "suchAsDigits": "如：流水号位数：1<=流水号长度<=20",
    "serialNumberExample": "流水号示例",
    "pleaseEnterPrefix": "请输入前缀",
    "pleaseEnterSuffix": "请输入后缀",
    "currentMaxSerialNumber": "当前流水号最大值",
    "pleaseEnterCurrentMaxSerialNumber": "请输入当前流水号最大值",
    "pleaseSelectUsingOrganizationShortName": "请选择使用的单位简称",
    "inputOrganizationName": "输入机构名称",
    "dateFormat": "日期格式",
    "dateFormatExplanation": "该日期格式表示流水号按某种日期规则更新，如[yyyyMM]表示按照月更新，其中：yy代表年,MM代表月,DD代表日",
    "suchAsDateFormat": "如：yyyyMMdd",
    "resetSerialNumber": "是否重置",
    "resetExplanation": "年份或月份发生变化，重置流水号最大值为1，如日期格式为[yyyyMM]，当前是5月，当前流水号为[2023050088]，到6月份时，是否重置为是，新流水号为2023060001，为否则为2023060089",
    "pleaseEnterRemarks": "请输入备注",
    "exceedsTwentyCharacters": "长度超过20个字符",
    "details": "详情",
    "reviewPassed": "审核通过",
    "rejectApplication": "驳回申请",
    "rejectApplicationReason": "驳回申请原因",
    "rejectReason": "驳回原因(",
    "userInfo": "用户信息",
    "beforeModification": "修改前",
    "deletedNotViewable": "已删除,不可查看",
    "afterModification": "修改后",
    "phoneNumber": "电话号码",
    "jobTitle": "职务名称",
    "userInfo": "用户信息",
    "beforeModification": "修改前",
    "afterModification": "修改后",
    "pleaseFillInRejectReasonCarefully": "请认真填写驳回原因，便于申请人员进行调整"
  },
  sumUser: {
    "pleaseSelectAffiliatedOrganization": "请选择所属机构",
    "pleaseSelectRole": "请选择角色",
    "pleaseSelectStatus": "请选择状态",
    "confirmLockUser": "锁定后用户将不能登录系统，是否确定锁定用户？",
    "confirmUnlockUser": "解锁后用户将能登录系统，是否确定解锁用户？",
    user: '用户',
    userAccount: '用户名',
    personName: '姓名',
    sex: '性别',
    birthdate: '出生日期',
    orgCode: '单位编码',
    status: '用户状态',
    phone: '手机号码',
    email: '邮箱',
    position: '职务',
    photo: '头像',
    signPhoto: '电子签名',
    sumUser: '用户表信息',
    password: '密码',
    staffNo: '员工号',
    roleNames: '角色列表',
    orgName: '机构名称',
    remarks: '备注',
    operationType: '审批类型',
    filters: {
      org: '所属机构',
      selectArea: '查询范围',
      selectAreaTip: '请选择查询范围',
      personName: '姓名',
      personNameTip: '可通过姓名模糊查询',
      phone: '手机号',
      phoneTip: '请输入手机号码',
      role: '角色',
      username: '用户名',
      status: '状态',
      search: '查询',
      new: '新增',
      searchScope: {
        own: '仅本单位',
        withSubOrg: '本单位及下属单位'
      },
    },
    operation: {
      resetPwd: '重置密码',
      resetPwdSuccess: '重置密码成功',
      resetPwdError: '重置密码失败',
      resetPwdTip: `确认重置用户{}的密码为（${projectCfg.defaultPassword?projectCfg.defaultPassword:'abc.123'}）吗?`,
      tip: '提示',
      lock: '锁定',
      lockTip: '是否确定解除用户与[{}]的关联关系？',
      unlock: '解锁',
      unlockTip: '确认要解锁用户{}吗?',
      userExistsTip: '该用户已在其他机构维护，是否继续添加为本机构用户？',
    }
  },
  sumRole: {
    roleCode: '角色编码',
    roleName: '角色名称',
    status: '状态',
    detail: '备注',
    sumRole: '角色表信息',
    level: '角色级别',
    saveConfirm: '您确定要保存吗？',
    deleteRowConfirm: "您确定要删除角色‘{name}’吗？",
    notDictMenuConfirm: "当前角色“{name}”尚未被分配词典管理页面的权限。是否要确认授权？",
    secondDeleteConfirm: "'{name}'您确定删除该角色关联的用户吗？",
    "queryByRoleNameFuzzy": "可通过角色名称模糊查询",
    "dictionaryAuthorization": "字典授权",
    "menuAuthorization": "菜单授权",
    "homePageAuthorization": "首页授权",
    "submitForReview": "提交审核",
    "cancelModification": "取消修改",
    "confirmSubmitForReview": "确定要提交审核吗?",
    "confirmCancelModification": "确定要取消修改吗?",
    "homeModule": "首页模块",
    "queryByDictionaryType": "可根据字典类型查询"
  },
  sysModule: {
    moduleName: '模块名称',
    detail: '备注',
    sysModule: '模块表信息'
  },
  sumApi: {
    apiName: '权限名称',
    apiType: 'api类型',
    apiUri: 'api路径',
    apiDetail: 'api说明',
    apiClazzId: '所属菜单',
    apiTag: '标签',
    sumApi: '权限表信息'
  },
  sumOrgApprovalWay: {
    orgCode: '单位编码',
    rootOrgCode: '一级单位编码',
    reportApprovalWay: '审批上报方式',
    backApprovalWay: '审批退回方式',
    sumOrgApprovalWay: '单位审批方式表'
  },
  flow: {
    orgCode: '机构编码',
    flowCode: '流程编码',
    flowName: '业务流名称',
    flow: '流程信息表',
    owner: '归属单位',
    isCollect: '是否汇总',
    isAutoAccept: '是否自动受理'
  },
  city: {
    countryId: '国家',
    cityEname: '城市英文名称',
    cityCname: '城市中文名称',
    currency: '币种',
    accommodationFee: '住宿费',
    foodFee: '伙食费',
    sundryFee: '公杂费',
    accreditationFee: '办证费',
    city: '城市基础表信息',
    currencyLabel: '请选择币种',
    search: {
      country: '国家',
      city: '城市',
      countryLabel: '请选择国家',
      cityLabel: '可通过城市名称模糊查询'
    }
  },
  businessLog: {
    logTypeName: "日志类型",
    orgName: "操作人机构",
    realName: "操作人",
    userName: "用户名",
    operationTypeName: "动作",
    businessTypeName: "功能模块",
    businessChildrenTypeName: "子模块",
    businessKey: "业务编号",
    ipAddr: "IP地址",
    businessLogTitle: "业务日志查询",
    operation: "操作内容",
    createDate: "时间",
    "export": "导出",
    "functionSubmodule": "功能子模块",
    "logTime": "日志时间",
    "advancedSearch": "高级搜索",
    "operationLog": "操作日志",
    "businessLog": "业务日志",
    "approvalLog": "审批日志",
    "yesterday": "昨天",
    "today": "今天",
    "lastWeek": "上周",
    "thisWeek": "本周",
    "lastMonth": "上月",
    "thisMonth": "本月",
    "logDataIsEmptyCannotExport": "日志数据为空不可导出",
    "log": "日志",
    "logTime": "日志时间",
    "to": "至"
  },
  systemConfiguration: {
    "systemName": "系统名称",
    "pleaseEnterSystemName": "请输入系统名称",
    "pleaseUploadSystemIcon": "请上传系统图标",
    "pleaseUploadSystemBackgroundImage": "请上传系统背景图",
    "systemStyle": "系统样式",
    "systemIcon": "系统图标",
    "systemBackgroundImage": "系统背景图片",
    "uploadIconImageSizeCannotExceed": "上传图标图片大小不能超过 1MB!",
    "uploadImageWidthAndHeightCannotExceed600Pixels": "上传图片宽度不能超过600像素，高度不能超过600像素",
    "uploadBackgroundImageSizeCannotExceed": "上传背景图片大小不能超过 2MB!",
    "uploadImageWidthCannotExceed1920PixelsAndHeightCannotExceed1080Pixels": "上传图片宽度不能超过1920像素，高度不能超过1080像素",
    "confirmDeleteSystemImageAreYouSure": "确定删除系统图片吗, 是否继续?",
    "confirm": "确定",
    "cancel": "取消",
    "cancelledDeletion": "已取消删除",
    "successfullyAddedSystemInformation": "新增系统信息成功",
    "successfullyModifiedSystemInformation": "修改系统信息成功"
  },
  rules: {
    lengthBetween: '长度在{}到{}个字符之间',
    "deleteThisLine": "请删除该行，仅用于占末位"
  },
  sumApp: {
      tabIndex: '序号',
      appCode: '应用编码',
      appName: '应用名称',
      appFullName: '应用全称',
      appType: '应用类型',
      appSecret: '应用密钥',
      status: '应用状态',
      appUrl: '应用地址',
      remarks: '备注说明',
      loginUrl: '应用登录地址',
      sumApp: '应用信息表',
      appEnable: '启用',
      appDisable: '禁用',
      appIcon: '应用图标'
    },
  logain: {
    "welcomeLogin": "欢迎登录",
    "inputLoginAccount": "请输入登录账号",
    "inputLoginPassword": "请输入登录密码",
    "inputMobileNumber": "请输入手机号码",
    "inputSmsVerificationCode": "请输入6位短信验证码",
    "inputUsername": "请输入用户名",
    "inputPassword": "请输入密码",
    "getVerificationCode": "获取验证码",
    "inputMobileNumberForVerification": "请输入手机号码",
    "usernameLogin": "用户名登录",
    "smsLogin": "短信登录",
    "userLogin": "用户登录",
    "resendLater": "后重发",
    "clickToResend": "点击重发"
  },

  //错误提醒
  errorMsg: {
    MsgErr001: '登录信息获取不到，请重新登录',
    MsgErr002: '单位与登录账户单位不符，请重新登录',

    MsgErrC2001001: '单位计划未开启',
    MsgErrC2001002: '下级单位已全部发布，不能设置截止日期',
    MsgErrC2001003: '存在未申报截止日期的下级单位，不能计划发布',
    MsgErrC2001004: '单位不存在直属单位，不能计划发布',
    MsgErrC2001005: '不存在未发布未锁定的下级单位，不能计划发布',
    MsgErrC2001006: '本单位信息获取失败',
    MsgErrC2001007: '计划开启失败',
    MsgErrC2001008: '获取直属单位机构信息错误',
    MsgErrC2001009: '设置申报截止日期错误',
    MsgErrC20010010: '获取直属单位计划指标信息失败',
    MsgErrC20010011: '计划发布失败',
    MsgErrC20010012: '只能操作直属下级单位的上报权限',
    MsgErrC20010013: '锁定/解锁操作失败',
    MsgErrC20010014: '截止日期不能为空',
    MsgErrC20010015: '计划年度不能为空',
    MsgErrC20010016: '单位不能为空',
    MsgErrC20010017: '设置截止日期失败',
    MsgErrC20010018: '通知信息保存失败',
    MsgErrC20010019: '获取通知附件信息失败',
    MsgErrC20010020: '获取单位指标信息失败',
    MsgErrC20010021: '参数id不能为空',

    MsgErrC2002001: '计划指标未发布',
    MsgErrC2002002: '计划指标状态不能新建计划',
    MsgErrC2002003: '限量计划批次已用完，不能新建计划',
    MsgErrC2002004: '限量计划人次已用完，不能新建计划',
    MsgErrC2002005: '超过计划截止日期提醒',
    MsgErrC2002006: '计划为空',
    MsgErrC2002007: '请添加出访地',
    MsgErrC2002008: '',
    MsgErrC2002009: '',
    MsgErrC2002010: '',
    MsgErrC2002011: '',
    MsgErrC2004001:'获取批复指标信息错误',
    MsgErrC2004002:'获取最终批复计划单位列表失败',
    MsgErrC2004003:'获取单位计划列表失败',
    MsgErrC2004004:'获取计划详情失败',
    MsgErrC2004005:'查询出访地列表失败',
    MsgErrC2004006:'计划审核失败',
    MsgErrC2004007:'批复指标设置失败',
    MsgErrC2004008:'批准并通知失败',
    MsgErrC2004009:'计划年度不能为空',
    MsgErrC2004010:'单位编码不能为空',
    MsgErrC2004011:'非当前单位的子单位',
    MsgErrC2004012:'计划编号不能为空',
    MsgErrC2004013:'计划不存在',
    MsgErrC2004014:'计划已经关联团组被使用,不允许执行不批操作',
    MsgErrC2004015:'年度计划指标信息不存在',
    MsgErrC2004016:'年度计划已发布通知,禁止操作',
    MsgErrC2004017:'单位计划已通知,禁止重复操作',
  },
  signRecord: {
    tableName: '签名表',
    primaryKey: '主键字段',
    primaryValue: '主键值',
    signFields: '签名字段',
    signValue: '签名值',
    signTime: '签名时间',
    signFirstTime: '首次签名时间',
    sqlLikeFields: '签名表名称, 签名表主键字段名, 主键值, 签名值',
    signRecord: '签名记录',
    status: '状态'
  }
}
